import React from 'react';
import { Link } from 'react-router-dom';
import './Buttons.css';
import { LoadingDots } from 'Components/LoadingDots';

export const Button = ({ children, className, onClick, disabled, submitting }) => {
  return (
    <button onClick={onClick} className={className} type="submit" disabled={disabled}>
      {submitting ? <LoadingDots /> : children}
    </button>
  );
};

export const CancelButton = ({ text, onClick, className }) => (
  <button onClick={onClick} className={`cancelButton ${className}`} type="button">
    {text}
  </button>
);

export const SubmitButton = ({
  text = 'Submit',
  onClick,
  isDisabled,
  mockDisabled,
  className = '',
  submitting,
  modernLayout,
  isObstructed = false,
}) => {
  const submittingClassName = submitting ? 'buttonSubmitting' : '';
  const mockDisabledClassName = mockDisabled ? 'buttonMockDisabled' : '';

  return (
    <Button
      onClick={onClick}
      className={`formSubmit${isObstructed ? ' keyboardActive' : ''}${
        modernLayout ? ' modernLayout' : ''
      } ${className} ${submittingClassName} ${mockDisabledClassName}`}
      disabled={submitting || isDisabled}
      submitting={submitting}
    >
      {submitting ? <LoadingDots /> : text}
    </Button>
  );
};

export const LinkSubmitButton = ({
  path,
  state = null,
  text,
  className = '',
  submitting,
  onClick,
  modernStyle,
  inline,
  isDisabled,
}) => (
  <Link
    onClick={onClick}
    to={path}
    state={state}
    className={`formSubmit linkButton${modernStyle ? ' modernStyle' : ''}${inline ? ' inline' : ''} ${className}${
      isDisabled ? ' disabled' : ''
    }`}
  >
    {submitting ? <LoadingDots /> : text}
  </Link>
);

export const StaticLinkButton = ({ path, text, className = '', onClick }) => {
  const isExternalLink = typeof path === 'string' && !!path.match(/http/i);
  if (isExternalLink) {
    return (
      <a href={path} onClick={onClick} className={`linkButton ${className}`}>
        <SubmitButton text={text} />
      </a>
    );
  }

  return (
    <Link to={path} state={{ from: path }} onClick={onClick} className={`linkButton ${className}`}>
      <SubmitButton text={text} />
    </Link>
  );
};

export const SmallButton = ({ text = 'Submit', onClick, isDisabled, submitting }) => (
  <button onClick={onClick} className="smallButton" type="submit" disabled={isDisabled}>
    {submitting ? <LoadingDots /> : text}
  </button>
);

export const PillButton = ({
  text = 'Submit',
  type = null,
  modernLayout,
  className = '',
  onClick,
  isDisabled,
  submitting,
}) => (
  <button
    onClick={onClick}
    className={`pillButton ${className}${modernLayout ? ' modernLayout' : ''}`}
    {...(type && { type })}
    disabled={isDisabled}
  >
    {submitting ? <LoadingDots /> : text}
  </button>
);
